import {useEffect, useState} from 'react';
import styles from './baseLegalDocuments.module.scss';
import v2 from '../../v2/instrumentV2.module.scss';
import {FormCard, spans} from '../../v2/FormCard';
import {InstrumentActions} from '../../v2/InstrumentActions';
import {DOCUMENTS_MOCK} from '../../v2/devPrefill';
import {useRemainingFields} from '../../v2/useRemainingFields';
import plusIcon from 'images/plus-circle.png';
import cloudIcon from 'images/cloud-upload.svg';
import deleteIcon from 'images/delete.svg';
import {Form, Input, Upload} from 'antd';
import FadeEffect from 'components/animation/fadeEffect';
import {UploadDocumentToBucket} from 'pages/campaigns/new/screens/legalDocument/uploadDocument';
import {useSelector} from 'react-redux';
import {NavTabsEnum} from 'utils/constants';
import {makeSelectTabOperations} from 'redux/store/auth';

const BaseLegalDocument = ({onSubmit, existingData}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const isDev = process.env.REACT_APP_API_BASE_URL.includes('.daba-dev.');

  const pageOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.assetClasses),
  );

  const [remaining, onValuesChange] = useRemainingFields(
    form,
    [],
    existingData,
  );

  useEffect(() => {
    if (existingData && existingData.documents) {
      form.setFieldsValue({documents: existingData.documents});
    }
  }, [existingData]);

  const handleChangeFile = async (i, {file}) => {
    const temp = file.originFileObj;

    const newFormValues = [...form.getFieldValue('documents')];

    newFormValues[i].fileName = temp.name.split('.')[0];

    setLoading(true);
    const bucket = isDev
      ? 'dabafinancialinstruments-nonprod'
      : 'dabafinancialinstruments-prod';
    try {
      const fileLink = await UploadDocumentToBucket(
        temp,
        () => {},
        bucket,
        true,
        'bonds',
      );
      newFormValues[i].fileLink = fileLink ?? null;
    } catch (error) {
      console.error('File upload failed:', error);
    } finally {
      setLoading(false);
      form.setFieldsValue({documents: newFormValues});
    }
  };

  return (
    <div>
      <div className={v2.bodyHead}>
        <h2>Documents</h2>
        <p>
          Prospectus, term sheet, information memorandum — anything an investor
          should be able to read before committing.
        </p>
      </div>

      <Form
        onFinish={values => {
          onSubmit({
            documents: values?.documents
              ? values?.documents?.map(data => ({
                  name: data?.name,
                  language: data?.language,
                  fileLink: data?.fileLink,
                }))
              : null,
          });
        }}
        form={form}
        onValuesChange={onValuesChange}
        layout="vertical">
        <FormCard
          title="Legal documents"
          description="PDF or DOC. Each one is listed against the instrument on mobile.">
          <Form.List name="documents">
            {(fields, {add, remove}) => (
              <div className={v2.rows}>
                {fields.map(({key, name}) => (
                  <FadeEffect key={key}>
                    <div className={v2.row}>
                      <div className={spans.half}>
                        <Form.Item
                          name={[name, 'name']}
                          rules={[{required: true, message: 'Required'}]}
                          label="Document name">
                          <Input placeholder="Information memorandum" />
                        </Form.Item>
                      </div>
                      <div className={spans.half}>
                        <Form.Item
                          name={[name, 'fileLink']}
                          rules={[{required: true, message: 'Required'}]}
                          label="File">
                          <Upload
                            accept=".pdf, .doc"
                            name="pdf"
                            onChange={e => handleChangeFile(name, e)}
                            maxCount={1}>
                            <label
                              htmlFor="file-upload"
                              className={styles.upload}>
                              <img src={cloudIcon} alt="" />
                              <span>
                                {typeof form.getFieldValue('documents')[name]
                                  ?.fileLink === 'string'
                                  ? 'Uploaded'
                                  : typeof form.getFieldValue('documents')[name]
                                      ?.fileLink === 'object'
                                  ? 'Uploading…'
                                  : 'Upload document'}
                              </span>
                            </label>
                          </Upload>
                        </Form.Item>
                      </div>
                      <div className={v2.rowDelete}>
                        <img
                          onClick={() => remove(name)}
                          src={deleteIcon}
                          alt="Remove document"
                        />
                      </div>
                    </div>
                  </FadeEffect>
                ))}
                <button type="button" onClick={add} className={v2.addRow}>
                  <img src={plusIcon} alt="" />
                  <span>Add document</span>
                </button>
              </div>
            )}
          </Form.List>
        </FormCard>

        <InstrumentActions
          onPrepopulate={() => {
            form.setFieldsValue(DOCUMENTS_MOCK);
            onValuesChange();
          }}
          remaining={remaining}
          disabled={loading || !pageOperations?.update}
          label={loading ? 'Please wait…' : 'Save and continue'}
        />
      </Form>
    </div>
  );
};

export default BaseLegalDocument;
